import { useQuery } from 'react-query';
import { fetchSessionInfo } from '../apiCalls';
import { QueryKey } from './QueryKeys';

// Query for the session info.
const useSessionInfo = () => {
	// StartRegion: Set initial data to an empty object so that we don't have to use optional chaining if the data is not available.
	const { data = {}, isLoading } = useQuery(QueryKey.GET_SESSION_INFO, fetchSessionInfo);

	const { session = {}, programs = [], flows = [], features = [], memberInfo = {} } = data;

	const {
		clientLogo,
		clientLogoXs,
		phoneNumbers,
		paymentHistoryBlob,
		ssId = '',
	} = session;

	const {
		firstName,
		lastName,
		phoneNumber,
		address,
		eligPlanID,
		healthPlanName,
		dateOfBirth,
		eligMemberSuffix,
		eligMemberId,
		contractId,
		email,
	} = memberInfo;
	// EndRegion: Set initial data to an empty object so that we don't have to use optional chaining if the data is not available.

	const isLoggedIn = !!session.ssId;
	const hasProgram = !!programs.length > 0;

	// isCompleted property keeps track of user flows
	const completedFlows = flows.map(flow => ({
		...flow,
		isCompleted: false,
	}));

	return {
		isLoading,
		isLoggedIn,
		hasProgram,
		memberPrograms: programs,
		ssId,
		firstName,
		lastName,
		memberPhoneNumber: phoneNumber,
		address,
		eligPlanID,
		healthPlanName,
		dateOfBirth,
		eligMemberSuffix,
		eligMemberId,
		contractId,
		email,
		flows: completedFlows,
		phoneNumber: phoneNumbers?.phoneNumber,
		coachingPhoneNumber: phoneNumbers?.coachingPhoneNumber,
		hasDigitalWorkouts: features.includes('DigitalWorkouts'),
		hasOTC: features.includes('OTC'),
		clientLogo: clientLogo?.url,
		clientLogoXs: clientLogoXs?.url,
		isWhiteLabeling: !!clientLogo?.hideSiteLogo,
		paymentHistoryBlob,
		secureMessaging: features.includes('SecureMessaging'),
		features,
		hasBuyHealthyVendorDiscounts: features.includes('BuyHealthyMarketplace'),
		hasEnableMessageCenterEmailNotification: features.includes(
			'EnableMessageCenterEmailNotification'
		),
	};
};

export default useSessionInfo;
